module.exports = __webpack_public_path__ + "static/media/exclaim.af7bb446.svg";